import PropTypes from 'prop-types';
import Login from '@cont/Login/Login';
import {
  StyledPaper,
  ClassTitle,
  ClassSubTitle,
  Fire,
  Flex,
  BookAClassForm,
  RequeestOtpForm,
  BookAClassContainer
} from './styles';
import Form from './Form';

const BookAClass = ({ state, dispatch, handleSourceLogin, heroForm }) => {
  const { title, subTitle, url } = heroForm.header;
  const { name, email, phoneNumber, form } = state;
  const bookForm = ['BOOK_FORM', 'CLASS_BOOKED'].includes(form);
  const loginForm = form === 'LOGIN_FORM';
  const updateForm = (type) => {
    dispatch({
      type: 'SET_FORM',
      payload: type || (loginForm ? 'BOOK_FORM' : 'LOGIN_FORM')
    });
  };
  return (
    <BookAClassContainer>
      <StyledPaper>
        <BookAClassForm $display={bookForm}>
          <ClassTitle>{title}</ClassTitle>
          {subTitle ? (
            <Flex>
              <Fire src={url.default} alt="fire" width="14px" height="14px" />
              <ClassSubTitle>{subTitle}</ClassSubTitle>
            </Flex>
          ) : null}
          <Form
            updateForm={updateForm}
            state={state}
            dispatch={dispatch}
            heroForm={heroForm}
          />
        </BookAClassForm>
        <RequeestOtpForm $display={loginForm}>
          {loginForm && (
            <Login
              source="page"
              showOtpField
              phoneNumber={phoneNumber}
              hideHelp
              sourceType="marketing"
              updateForm={updateForm}
              handleSourceLogin={handleSourceLogin}
              userInfo={{ name, email, phoneNumber }}
            />
          )}
        </RequeestOtpForm>
      </StyledPaper>
    </BookAClassContainer>
  );
};

BookAClass.propTypes = {
  handleSourceLogin: PropTypes.func.isRequired,
  state: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
  heroForm: PropTypes.objectOf(PropTypes.any).isRequired
};

export default BookAClass;
